"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onUserDataFetchSuccess = void 0;
var _models = require("../models");
const onUserDataFetchSuccess = ({
  currentType,
  setInputData
}) => fetchedData => {
  if (fetchedData.email && currentType === _models.BackInStockNotificationChannel.Email) {
    setInputData(fetchedData.email);
  } else if (fetchedData.telephoneNumber && currentType === _models.BackInStockNotificationChannel.Sms) {
    setInputData(fetchedData.telephoneNumber);
  }
};
exports.onUserDataFetchSuccess = onUserDataFetchSuccess;
